import { Box, CircularProgress, Sheet, Stack, Typography } from "@mui/joy";
import { Outlet, useLocation } from "react-router";
import { useMoonMeet, isMeetingPath } from '../moonmeet/MoonMeetProvider';
import HeaderLK from "../components/HeaderLK/HeaderLK";
import Sidebar from "../components/Sidebar/Sidebar";
import RouteErrorBoundary from "../components/RouteErrorBoundary";

import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { useContext, useRef, useState } from "react";
import { LayoutContext } from "../context";



export default function LKPage({ children }) {
    const moonMeet = useMoonMeet();
    const { loadDealList, loadListEvents } = useContext(LayoutContext);
    const location = useLocation();
    const reduced = useReducedMotion();
    const [drawerExpanded, setDrawerExpanded] = useState(() => { try { return localStorage.getItem('lunadesk.drawer.expanded.v1') === 'true'; } catch { return false; } });
    const boardId = new URLSearchParams(location.search).get('board') || '';
    const drawerWide = location.pathname === '/drawer' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(boardId) && drawerExpanded;
    const meetingWide = isMeetingPath(location.pathname) && new URLSearchParams(location.search).get('view') !== 'meetings' && !!moonMeet?.session && moonMeet.expanded;
    const expanded = drawerWide || meetingWide;
    function toggleDrawerExpanded() { setDrawerExpanded(value => { try { localStorage.setItem('lunadesk.drawer.expanded.v1', String(!value)); } catch {} return !value; }); }

    // useEffect(() => {
    //     // Выполняется каждый раз, когда изменяется текущий путь
    //     // console.log("Путь изменился на:", location.pathname);
    //     closeSidebar();
    // }, [location]);

    const scrollContainerRef = useRef(null); // Референс на блок для прокрутки

    
    return (
        <Box data-workspace-expanded={expanded ? 'true' : 'false'} sx={{ display: 'flex', height: '100dvh', minHeight: 0, overflow: 'hidden' }}>
            <Sidebar compact={expanded} onExpand={() => meetingWide ? moonMeet.setExpanded(false) : toggleDrawerExpanded()}/>

            <Box
                ref={scrollContainerRef}
                sx={{
                    overflow: (['/drawer', '/notes', '/tasks'].includes(location.pathname) || isMeetingPath(location.pathname)) ? 'hidden' : 'auto',
                    minWidth: 0,
                    height: '100%',
                    width: '100%',
                    display: 'flex', flexDirection: 'column', minHeight: 0,
                    boxSizing: 'border-box',
                    pt: expanded ? 1 : 0,
                    pl: expanded ? 1 : { xs: 1, md: 0 },
                    pr: 1
                }}
            >
                <AnimatePresence initial={false}>{!expanded && <motion.div key="workspace-header" initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: reduced ? 0 : .2 }} style={{ flexShrink: 0, overflow: 'hidden' }}><HeaderLK/></motion.div>}</AnimatePresence>
                
                { !expanded && (loadDealList || loadListEvents) && (
                    <Stack direction={'column'} spacing={1} sx={{ mx: 2, mt: 2 }}>
                        { loadDealList && (
                            <Sheet
                                variant="soft"
                                color="primary"
                                sx={{
                                    p: 1,
                                    mx: 2,

                                    borderRadius: 'lg',
                                    
                                }}
                            >
                                <Stack direction={'row'} spacing={2} alignItems={'center'}>
                                    <CircularProgress size={"sm"}/>
                                    <Typography color="primary" sx={{ lineHeight: 1.1, fontSize: "clamp(0.8rem, 2.5vw, 1rem)", fontWeight: 500 }}>
                                        Загружаю сделки Bitrix. Подождите чуть чуть))
                                    </Typography>
                                </Stack>
                            </Sheet>
                        )}

                        { loadListEvents && (
                            <Sheet
                                variant="soft"
                                color="success"
                                sx={{
                                    p: 1,
                                    mx: 2,

                                    borderRadius: 'lg',
                                    
                                }}
                            >
                                <Stack direction={'row'} spacing={2} alignItems={'center'}>
                                    <CircularProgress size={"sm"} color="success"/>
                                    <Typography color="success" sx={{ lineHeight: 1.1, fontSize: "clamp(0.8rem, 2.5vw, 1rem)", fontWeight: 500 }}>
                                        Загружаю события Календаря)
                                    </Typography>
                                </Stack>
                            </Sheet>
                        )}
                    </Stack>
                )}
                
                <Box
                    className="MainContent"
                    sx={{
                        // px: { xs: 2, md: 6 },
                        // mt: {
                        //     xs: 2,
                        //     md: 3,
                        // },
                        // pb: { xs: 2, sm: 2, md: 3 },
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: 0,
                        gap: 1,
                        mb: 1,
                        minHeight: 0,
                    }}
                >
                    <motion.main
                        key={location.pathname}
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 40 }}
                        style={{ height: "100%", minHeight: 0, minWidth: 0, display: 'flex', flexDirection: 'column' }}
                    >
                        <RouteErrorBoundary key={location.pathname}>{children || <Outlet context={{ scrollContainerRef, drawerExpanded: drawerWide, toggleDrawerExpanded }}/>}</RouteErrorBoundary>
                    </motion.main>
                </Box>
            </Box>
        </Box>
    );
}
